<template>
  <div class="nav-bar-close">
    <div class="nav-bar-wrapper van-hairline--bottom">
      <div class="nav-left">
        <button @click="close" class="back">
          <img src="../assets/img/arrow-left.png" alt="">
          <span v-show="leftText">返回</span>
        </button>
      </div>
      <div class="title">{{title}}</div>
      <div class="nav-right">
        <button @click="home" class="home" v-show="showHome"></button>
        <slot name="btn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'close',
  props: {
    title: {
      type: String
    },
    leftText: {
      type: Boolean,
      default: true
    },
    showHome: {
      type: Boolean
    }
  },
  methods: {
    close () {
      this.$emit('close', true)
    },
    home () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="less" scoped>
.nav-bar-close {
  width: 100%;
  height: 0.88rem;
}
.nav-bar-wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  font-size: @fz32;
  .flex-center;
  height: 0.88rem;
  color: @base;
  background-color: #fff;
  z-index: 999;
  .nav-left {
    position: absolute;
    left: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
    font-size: @fz26;
    .flex-center;
    .back {
      .flex-center;
      img {
        width: 0.2rem;
        object-fit: contain;
        padding-right: 0.15rem;
      }
    }
  }

  .nav-right {
    position: absolute;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    font-size: @fz26;
    .edit {
      width: 0.9rem;
      height: 0.48rem;
      color: @base;
      background-color: #f0f0f0;
      border-radius: 30px;
    }
    .finished-edit {
      color: #f5a623;
    }
    .home {
      width: 0.58rem;
      height: 0.58rem;
      background: url("../assets/img/home.png") center no-repeat;
      background-size: 100%;
    }
  }
}
</style>
